export var ManagerApprovalType;
(function (ManagerApprovalType) {
    ManagerApprovalType["SKIP_DRIVER_LICENSE_IMAGE"] = "SKIP_DRIVER_LICENSE_IMAGE";
    ManagerApprovalType["SKIP_DRIVER_LICENSE_VALIDATION"] = "SKIP_DRIVER_LICENSE_VALIDATION";
    ManagerApprovalType["SKIP_PAYMENT"] = "SKIP_PAYMENT";
    ManagerApprovalType["EDIT_DRIVER_LICENSE_INFO"] = "EDIT_DRIVER_LICENSE_INFO";
    ManagerApprovalType["BLACK_LIST"] = "BLACK_LIST";
    // 예약과 무관한 키오스크 카드 결제 취소
    ManagerApprovalType["CANCEL_PAYMENT"] = "CANCEL_PAYMENT";
})(ManagerApprovalType || (ManagerApprovalType = {}));
